var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ [`col-md-${_vm.md}`]: _vm.isPrint, horizontal: _vm.isHorizontal }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }